import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getUserAgentTypeController from './getUserAgentTypeController.js'
import _module from 'module.js'
import _ from 'lodash'

let getUserAgentTypeComponent = _.cloneDeep(getJrnDefaultComponent)
getUserAgentTypeComponent.controller = getUserAgentTypeController

_module.component('getUserAgentType', getUserAgentTypeComponent)
